import { useState, useEffect } from "react"
import Button from 'react-bootstrap/Button'
import Collapse from 'react-bootstrap/Collapse';
import PropTypes from 'prop-types'
import axios from 'axios';

import callBackImg from "../../Assets/HubSpot/hb_settings_phone.png";
import copyNumberImg from "../../Assets/HubSpot/hb_copy.png";
import addContactImg from "../../Assets/HubSpot/hb_add_user.png";
import addCompanyImg from "../../Assets/HubSpot/hb_add_company.png";
import addTaskImg from "../../Assets/HubSpot/hb_add_task.png";
import loopImg from "../../Assets/HubSpot/hb_loop.png";
import checkImg from "../../Assets/HubSpot/hb_check.png";
import exclamationmarkImg from "../../Assets/HubSpot/hb_exclamationmark.png";
import questionmarkImg from "../../Assets/HubSpot/hb_questionmark.png";
import emptyImg from "../../Assets/HubSpot/hb_empty.png";

import userImg from "../../Assets/user.png";
import companyImg from "../../Assets/company.png";
import { Translate } from "../../Components/Translator"
import { proxyUrl, AssociateHsObject, ChangeAssociationsHsObject, DisassociateHsObject } from "./Utils.jsx";
import { IsEmptyString } from "../../Components/GeneralFunctions.jsx"

const userImgHtml = <img src={userImg} style={{width: "18px", display: "inline-block", marginLeft: "4px"}} title={Translate("Contact")}></img>;
const companyImgHtml = <img src={companyImg} style={{width: "20px", display: "inline-block", marginLeft: "3px"}} title={Translate("Company")}></img>;
var selectUpdateCallId = null; // Used to update the select element when the callId changes
var contactCompany = null; // Used to store the company that will be associated with a new contact

const CallNotificationHubspot = (props) => {
    const [selectedMatchButton, setSelectedMatchButton] = useState(null);
    const [previousCallId, setPreviousCallId] = useState(undefined);
    const [initButtonFlag, setInitButtonFlag] = useState(false);
    const [recognitionName, setRecognitionName] = useState("");
    const [openContactForm, setOpenContactForm] = useState(false);
    const [openCompanyForm, setOpenCompanyForm] = useState(false);
    const [matchIcon, setMatchIcon] = useState(null);
    const [notifTitle, setNotifTitle] = useState(null);
    const [repaint, setRepaint] = useState(0);

    const [hubspotBroadcastChannelNotif, SetHubspotBroadcastChannelNotif] = useState(new BroadcastChannel("cloudctiwebclient2024_hubspot_notification"));
    const [hubspotBroadcastChannelCti, SetHubspotBroadcastChannelCti] = useState(new BroadcastChannel("cloudctiwebclient2024_hubspot_cti"));
    useEffect(() => {
        hubspotBroadcastChannelNotif.addEventListener("message", function(event) {
            if (event.data.startsWith("matchesChanged")) {
                var newMatches = localStorage.getItem("hb_callMatches");
                if (newMatches != undefined && newMatches != "[]") {
                    var newMatchesParsed = JSON.parse(newMatches);
                    props.setIncomingMatches(newMatchesParsed);
                    SetDisplayedMatch(0, newMatchesParsed[0]);
                }
                else {
                    props.setIncomingMatches([]);
                    setRepaint(repaint + 1);
                }
            }
            else if (event.data.startsWith("selectIndexChanged:")) {
                var newSelectIndex = event.data.split(':')[1];
                const select = document.getElementById("matchSelect");
                if (select != undefined) {
                    var newMatches = localStorage.getItem("hb_callMatches");
                    var newMatchesParsed = JSON.parse(newMatches);
                    select.selectedIndex = newSelectIndex;
                    SetDisplayedMatch(newSelectIndex, newMatchesParsed[newSelectIndex]);
                }
            }
        });
    }, [])

    // No call information available
    if (props.callCopy == null || props.callCopy == undefined)
        return <div className={`${props.Brand == "bonline" ? "notification" : ""} nobackground textcentered`}>{Translate("No recent call information available")}</div>;
    
    const incomingMatches = props.incomingMatches;
    const callerNumber = props.callCopy.Direction.toLowerCase() === "outbound" ? props.callCopy.CalledNumber : props.callCopy.CallerNumber
    const callId = props.callCopy.CallId;
    const isOutboundCalling = props.callCopy.Direction.toLowerCase() === "outbound";

    const tableStyle = {
        left: "-5px",
        position: "relative"
    }
    const buttonStyle = {
        width: "35px"
    }
    const buttonImgStyle = {
        width: "100%"
    }
    const labelStyle = {display: "inline-flex", width: "100%"};
    const inputWrapperStyle = {flex: 1, display: "inline-flex", justifyContent: "flex-end"};
    const inputStyle = {width: "calc(100vw - 185px)"};
    const createContactForm = (engagementIdRef, callerNumber) => {
        const divStyle = {
            backgroundColor: "rgba(0,0,0,0.03)",
            padding: "5px"
        }
        return <Collapse in={openContactForm}>
            <div key={callerNumber + "" + engagementIdRef?.current} id = "createContactDiv" style={divStyle}>
                <b>{Translate("Create contact")}</b>
                <form id="contactCreateForm">
                    <label style={labelStyle}>{Translate("First name")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="firstname"
                                type="text"
                                defaultValue={"Contact " + callerNumber}
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <br/>
                    <label style={labelStyle}>{Translate("Last name")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="lastname"
                                type="text"
                                defaultValue=""
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <br/>
                    <label style={labelStyle}>{Translate("Email")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="email"
                                type="text"
                                defaultValue=""
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <br/>
                    <label style={labelStyle}>{Translate("Phone number")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="phonenumber"
                                type="text"
                                defaultValue={callerNumber}
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <div style={{position: 'relative'}}>
                        <label style={labelStyle}>{Translate("Company name")}:&nbsp;
                            <div style={inputWrapperStyle}>
                                <input id="contactscompanyname"
                                    defaultValue=""
                                    style={{ ...inputStyle, paddingRight: "48px", height: "calc(20px * var(--bs-body-line-height))" }}
                                    onKeyUp={(event) => {
                                        if (event.code == "Enter") {
                                            event.preventDefault();
                                            document.getElementById("searchcompany").click();
                                        }
                                        else {
                                            contactCompany = null;
                                            document.getElementById("companysearchstatus").src = emptyImg;
                                        }
                                    }}  
                                />
                            </div>
                        </label>
                        <div style={{ position: "absolute", right: "0px", top: "0px", display: "flex", alignItems: "center", gap: "6px" }}>
                            <img id="companysearchstatus" src={emptyImg} style={{width: "18px", display: "inline-block"}} title={Translate("Contact")}></img>
                            <button type="button" id="searchcompany" onClick={() => {
                                    SearchCompanyByName(document.getElementById("contactscompanyname").value);
                                }}>
                                <img src={loopImg} style={{width: "18px", display: "inline-block", marginTop: "-2px", marginRight: "-1px"}} title={Translate("Search company name")}></img>
                            </button>
                        </div>
                    </div>
                    <br/>
                </form>
                <Button className="primarybutton" style={{color: "black", width: "calc(100% - 8px)"}} onClick={() => { 
                    CreateContactAndAssociate(engagementIdRef, incomingMatches, props.setIncomingMatches).then(() => 
                    props.PressSaveCall(props.cti, incomingMatches, props.textAreaRef, props.engagementIdRef.current, JSON.parse(localStorage.getItem("hb_callMatches"))[0]));
                    }}> {Translate("Create")} </Button>
            </div>
        </Collapse>
    }

    async function SearchCompanyByName(cName) {
        const SecurityToken = localStorage.getItem("securitytoken")

        let statusImg = document.getElementById("companysearchstatus");
        if (!statusImg) // Form isn't rendered yet
            return;

        const result = await axios.post(proxyUrl + "/companyNameSearch",
            {
                name: cName,
                portalId: localStorage.hb_portalId
            },
            {
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + SecurityToken
                }
            })
        if (result.status === 200)
        {
            console.log(result.data)
            const data = result.data;
            if (data.nrMatches == 1) {
                document.getElementById("contactscompanyname").value = data.name;
                contactCompany = { associatedcompanyid: data.hs_object_id, associatedcompanyname: data.name };
                statusImg.src = checkImg;
                statusImg.title = Translate("Company found and selected");
                return;
            }
            else if (data.nrMatches > 1) {
                statusImg.title = Translate("Multiple companies found, please refine your search");
                statusImg.src = questionmarkImg;
            }
            else {
                statusImg.title = Translate("No company found");
                statusImg.src = questionmarkImg;
            }
        }
        else
        {
            console.log(result)
            statusImg.src = exclamationmarkImg;
            statusImg.title = Translate("Something went wrong, please contact support");
        }
        contactCompany = null;
    }

    const createCompanyForm = (engagementIdRef, callerNumber) => {
        const divStyle = {
            backgroundColor: "rgba(0,0,0,0.03)",
            padding: "5px"
        }

        return <Collapse in={openCompanyForm}>
            <div key={callerNumber + "" + engagementIdRef?.current} id = "createCompanyDiv" style={divStyle}>
                <b>{Translate("Create company")}</b>
                <form id="companyCreateForm">
                    <label style={labelStyle}>{Translate("Name")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="name"
                                type="text"
                                defaultValue={"Company " + callerNumber}
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <br/>
                    <label style={labelStyle}>{Translate("Domain")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="domain"
                                type="text"
                                defaultValue=""
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <br/>
                    <label style={labelStyle}>{Translate("Phone number")}:&nbsp;
                        <div style={inputWrapperStyle}>
                            <input id="phonenumber"
                                type="text"
                                defaultValue={callerNumber}
                                style={inputStyle}
                            />
                        </div>
                    </label>
                    <br/>
                </form>
                <Button className="primarybutton" style={{color: "black", width: "calc(100% - 8px)"}} onClick={() => {
                    CreateCompanyAndAssociate(engagementIdRef, incomingMatches, props.setIncomingMatches).then(() =>
                    props.PressSaveCall(props.cti, incomingMatches, props.textAreaRef, props.engagementIdRef.current, JSON.parse(localStorage.getItem("hb_callMatches"))[0]));
                }}> {Translate("Create")} </Button>
                    
            </div>
        </Collapse>
    }
    const callBackButton = <Button className="primarybutton" 
        title={Translate("Call back")}
        onClick={() => {
            var name = null;
            var objectId = null;
            if (localStorage.hb_selectedIndex != null) {
                var selectedMatch = incomingMatches[localStorage.hb_selectedIndex];
                if (selectedMatch.callerIdType === "CONTACT") {
                    name = selectedMatch.firstName + " " + selectedMatch.lastName;
                }
                else if (selectedMatch.callerIdType === "COMPANY") {
                    name = selectedMatch.name;
                }
                objectId = selectedMatch.objectCoordinates.objectId;
            }
            props.MakeCall({ phoneNumber: callerNumber, name: name, objectId: objectId});
        }}
        style={buttonStyle}>
        <img src={callBackImg} style={buttonImgStyle}></img>
    </Button>
    // Copy the phonenumber to the clipboard
    // This is a workaround for Chrome, as it is stricter around navigator.clipboard.writeText
    const copyPhonenumberButton = <Button className="primarybutton" 
        title={Translate("Copy phonenumber")}
        onClick={async () => {
            try {
                await navigator.clipboard.writeText(callerNumber);
                console.log("Copied to clipboard.");
            }
            catch (err) { // Fallback for Chrome
                const tmp = document.createElement('textarea');
                tmp.value = callerNumber;
                tmp.style.position = 'fixed';   // avoid scrolling jump
                tmp.style.opacity = '0';
                document.body.appendChild(tmp);
                tmp.select();
                document.execCommand('copy');
                document.body.removeChild(tmp);
                console.log("Copied to clipboard with fallback method.");
            }
        }
        } 
        style={buttonStyle}>
        <img src={copyNumberImg} style={buttonImgStyle}></img>
    </Button>
    const createContactButton = <Button className="primarybutton" 
        onClick={() => { 
            setOpenContactForm(!openContactForm)
            setOpenCompanyForm(false);
        }}
        aria-controls="createContactDiv"
        aria-expanded={openContactForm}
        title={Translate("Create contact and link to call")}
        style={buttonStyle}>
        <img src={addContactImg} style={buttonImgStyle}></img>
    </Button>

    const createCompanyButton = <Button className="primarybutton"
        onClick={() => { 
            setOpenCompanyForm(!openCompanyForm)
            setOpenContactForm(false)
        }}
        aria-controls="createCompanyDiv"
        aria-expanded={openCompanyForm}
        title={Translate("Create company and link to call")}
        style={buttonStyle}>
        <img src={addCompanyImg} style={buttonImgStyle}></img>
    </Button>
    // Opens Contact/Company page in HubSpot and opens 'Add task' dialog within that page
    const AddTaskButton = <Button className="primarybutton"
        onClick={() => {
            const selectedIndex = localStorage.getItem("hb_selectedIndex");
            const match = incomingMatches[selectedIndex];
            window.open("https://app-eu1.hubspot.com/contacts/" + match.objectCoordinates.portalId + "/record/" + (match.callerIdType == "CONTACT" ? "0-1" : "0-2") + "/" + match.objectCoordinates.objectId + "?interaction=task", "_blank")
        }}
        title={Translate("Add task for chosen contact/company")}
        style={buttonStyle}
        disabled={incomingMatches == null || incomingMatches.length == 0}>
        <img src={addTaskImg} style={buttonImgStyle}></img>
    </Button>
    const quickActions = <>
        <table style={tableStyle}>
            <tbody>
                <tr>
                    <td>
                        {callBackButton}
                    </td>
                    <td>
                        {copyPhonenumberButton}
                    </td>
                    <td>
                        {createContactButton}
                    </td>
                    <td>
                        {createCompanyButton}
                    </td>
                    <td>
                        {AddTaskButton}
                    </td>
                </tr>
            </tbody>
        </table>
        {createContactForm(props.engagementIdRef, callerNumber)}
        {createCompanyForm(props.engagementIdRef, callerNumber)}
    </>

    // Make sure the date isn't updated every render
    if (previousCallId != callId) {
        setPreviousCallId(callId);
        setInitButtonFlag(true);
        setNotifTitle(<><b>{Translate(isOutboundCalling ? "Outbound call" : "Inbound call")}</b><br/></>)
        contactCompany = null;
    }

    // If no matches are available, show the caller number, matches and time
    if (incomingMatches) {
        if (incomingMatches.length > 0) {
            // Initialize the button to the first match
            if (initButtonFlag) {
                var index = localStorage.hb_selectedIndex ?? 0;
                SetDisplayedMatch(index);
                setInitButtonFlag(false);
                setRepaint(repaint + 1);
            }

            if (incomingMatches.length > 1) {
                if (selectUpdateCallId != callId) {
                    selectUpdateCallId = callId;
                    // Make sure the select is set to the last selected index if a call is in localstorage
                    // Keeps trying if the select element is being initialised but not available yet
                    var tries = 0;
                    const intervalId = setInterval(() => {
                        const select = document.getElementById("matchSelect");
                        if (select != undefined) {
                            const selectedIndex = localStorage.getItem("hb_selectedIndex");
                            if (selectedIndex != undefined && selectedIndex != "null") {
                                select.selectedIndex = selectedIndex;
                                SetDisplayedMatch(selectedIndex, incomingMatches[selectedIndex]);
                                clearInterval(intervalId);
                                return;
                            }
                        }
                        // try for 1 second, then stop
                        if (tries > 10)
                            clearInterval(intervalId);
                        else
                            tries++;
                    }, 100);
                }
                return <div>
                    { notifTitle }
                    <div style={{display: "inline-block", width:"52px"}}>{Translate("Name") + ": "}</div>
                    <select style={{width: "calc(100% - 75px)", fontWeight: "bold", display: "inline-block", "borderWidth": 0}} 
                        onChange={(e) => {
                            SetDisplayedMatch(e.target.selectedIndex);
                            hubspotBroadcastChannelNotif.postMessage("selectIndexChanged:" + e.target.selectedIndex);
                            localStorage.setItem("hb_selectedIndex", e.target.selectedIndex);
                        }} 
                        id="matchSelect">
                        {incomingMatches.map((match, index) => {
                            return <option key={index}>{
                                match.callerIdType === "CONTACT" ? 
                                (match.firstName ? match.firstName + " " : "") + (match.lastName ? match.lastName + " " : "") + (match.associatedcompanyname ? "(" + match.associatedcompanyname + ")" : "")
                                 : match.name ?? ""}</option>
                        })}
                    </select>
                    {matchIcon}
                    <div>{Translate("Number")}: {callerNumber}</div>
                    <div>{Translate("Time")}: {props.callTime}</div>
                    {quickActions}
                    {/* User scripts */}
                    {selectedMatchButton}
                </div>;
            }
            else {
                return <div>
                    { notifTitle }
                    {Translate("Name: ")}<b>{recognitionName}</b>{matchIcon}
                    <div>{Translate("Number")}: {callerNumber}</div>
                    <div>{Translate("Time")}: {props.callTime}</div>
                    {quickActions}
                    {/* User scripts */}
                    {selectedMatchButton}
                </div>;
            }
        }
        else
            return <div>
                { notifTitle }
                <div>{Translate("Number")}: {callerNumber}</div>
                <div>{Translate("Time")}: {props.callTime}</div> 
                {quickActions}
            </div>;
    }

    function SetDisplayedMatch(index, match = undefined) {
        if (match == undefined) 
            match = incomingMatches[index];        
        
        // Debug, this should not happen
        try {
            localStorage.hb_selectedMatchObjectId = match.objectCoordinates.objectId.toString();
        }
        catch (error) {
            console.error(error);
            console.log("Error while setting hb_selectedMatchObjectId in localStorage, this should not happen");
            console.log(match);
            console.log(incomingMatches);
            return;
        }

        /*
        if (lastAssociatedCallId != props.engagementIdRef.current  
            || lastAssociatedObjectId != match) 
        {
            AssociateHsObject(match, props.engagementIdRef.current); //also sets new localStorage.hb_lastAssociatedCallId and localStorage.hb_lastAssociatedObjectId
        }
            */
        
        // Execute after a new phonecall or when a different object is selected
        const lastAssociatedCallId = localStorage.hb_lastAssociatedCallId;
        const lastAssociatedObjectId = localStorage.hb_lastAssociatedObjectId;  
        const AssociateToObjectId = IsEmptyString(match.associatedcompanyid) ?  match.objectCoordinates.objectId : match.associatedcompanyid 
        if (lastAssociatedCallId != props.engagementIdRef.current  
            || lastAssociatedObjectId != AssociateToObjectId) 
        {
            ChangeAssociationsHsObject(props.engagementIdRef.current, match)
        }

        const isContact = match.callerIdType === "CONTACT"; // Else it should be "COMPANY"

        if (isContact) {
            setRecognitionName((match.firstName ? match.firstName + " " : "") + (match.lastName ? match.lastName + " " : "") + (match.associatedcompanyname ? "(" + match.associatedcompanyname + ")" : ""));
            setMatchIcon(userImgHtml);
        }
        else if (match.callerIdType == "COMPANY") {
            setRecognitionName(match.name);
            setMatchIcon(companyImgHtml);
        }
        else
            console.log("Error: unknown callerIdType: " + match.callerIdType);
        
        const select = document.getElementById("matchSelect");
        if (select != undefined) {
            select.selectedIndex = index;
            localStorage.hb_selectedIndex = index;
        }

        const recordButton = <Button onClick={() => 
                                window.open("https://app-eu1.hubspot.com/contacts/" + match.objectCoordinates.portalId + "/record/" + (match.callerIdType == "CONTACT" ? "0-1" : "0-2") + "/" + match.objectCoordinates.objectId, "_blank")}
                                className="scriptbutton brandbutton" 
                                style={{backgroundColor: "transparent"}}
                                variant={"outline-info"} 
                                title={"Open record in HubSpot"}>
                                {Translate("Open " + match.callerIdType.toLowerCase())}
                            </Button>

        var buttonContents = <></>;
        if (match.callerIdType == "CONTACT" && match.associatedcompanyid != null && match.associatedcompanyid != '')
            buttonContents = <>
                <td style={{width:"50%", paddingLeft: 0, paddingRight: 0, paddingBottom: 0}} key={0}>
                    {recordButton}
                </td>
                <td style={{padding: "2px"}}></td>
                <td style={{width:"50%", paddingLeft: 0, paddingRight: 0, paddingBottom: 0}} key={1}>
                    <Button onClick={() => 
                        window.open("https://app-eu1.hubspot.com/contacts/" + match.objectCoordinates.portalId + "/record/0-2/" + match.associatedcompanyid, "_blank")}
                    className="scriptbutton brandbutton" 
                    style={{backgroundColor: "transparent"}}
                    variant={"outline-info"} 
                    title={"Open primary association in HubSpot"}>
                        {Translate("Open company")}
                    </Button>
                </td>
            </>;
        else 
            buttonContents =  <td style={{width:"10%", paddingLeft: 0, paddingRight: 0, paddingBottom: 0}} key={0}> {recordButton} </td>;

        setSelectedMatchButton(
            <table cellPadding="5" width={"100%"}>
                <tbody>
                    <tr key={0}>
                        {buttonContents}
                    </tr>
                </tbody>
            </table>
        )
        
        setRepaint(repaint + 1);
    }

    async function CreateContactAndAssociate(engagementIdRef, incomingMatches, setIncomingMatches) {
        var firstNameForm = document.getElementById("firstname").value
        var lastNameForm = document.getElementById("lastname").value
        var emailForm = document.getElementById("email").value
        var phoneNumberForm = document.getElementById("phonenumber").value

        function StringIsValid(str) {
            return str != null && str != undefined && str != '';
        }

        if (!StringIsValid(firstNameForm) && !StringIsValid(lastNameForm) && StringIsValid(phoneNumberForm)) {
            firstNameForm = "Contact";
            lastNameForm = phoneNumberForm;
        }
        else if (!StringIsValid(firstNameForm) && !StringIsValid(lastNameForm) && !StringIsValid(phoneNumberForm)){
            console.log("Error: fill in at least one field");
            return;
        }

        const portalId = localStorage.hb_portalId;
        if (!portalId || portalId == "undefined") {
            console.error("Missing portalId, can't create contact");
            return;
        }
    
        const body = {
            "portalId": portalId,
            "engagementId": engagementIdRef.current,
            "properties": {
                "firstname": firstNameForm,
                "lastname": lastNameForm,
                "phone": phoneNumberForm,
                "email": emailForm,
                ...(contactCompany != null) && {"associatedcompanyid": contactCompany.associatedcompanyid}
            }
        };

        const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
        const foo = await axios.post(proxyUrl + "/addContactAndAssociation", body, config)
        .then(response => {
            const matchObj = response.data;
            if (contactCompany != null)
                matchObj.associatedcompanyname = contactCompany.associatedcompanyname;
            const newMatches = [matchObj, ...incomingMatches];
            setIncomingMatches(newMatches);
            SetDisplayedMatch(0, matchObj);

            // Make the new matches available in local storage and notify other tabs
            localStorage.setItem("hb_callMatches", JSON.stringify(newMatches));
            hubspotBroadcastChannelNotif.postMessage("matchesChanged");
            hubspotBroadcastChannelCti.postMessage("matchesChanged");

            console.log("Contact and Association succesfully added");
        }).catch((error) => {
            console.log("Error while creating contact: ", error); // TODO: Show error to user
        });

        setOpenContactForm(!openContactForm);
        document.getElementById("contactCreateForm").reset();
        contactCompany = null;
    }

    async function CreateCompanyAndAssociate(engagementIdRef, incomingMatches, setIncomingMatches) {
        var nameForm = document.getElementById("name").value
        var domainForm = document.getElementById("domain").value
        var phoneNumberForm = document.getElementById("phonenumber").value

        function StringIsValid(str) {
            return str != null && str != undefined && str != '';
        }

        if (!StringIsValid(nameForm) && !StringIsValid(domainForm) && StringIsValid(phoneNumberForm)) {
            nameForm = "Company";
            lastNameForm = phoneNumberForm;
        }
        else if (!StringIsValid(nameForm) && !StringIsValid(domainForm) && !StringIsValid(phoneNumberForm)){
            // TODO: Error message: fill something in!
            console.log("Error: fill in at least one field");
            return;
        }

        const portalId = localStorage.hb_portalId;
        if (!portalId || portalId == "undefined") {
            console.error("Missing portalId, can't create company");
            return;
        }

        const body = {
            "portalId": portalId,
            "engagementId": engagementIdRef.current,
            "properties": {
                "name": nameForm,
                "domain": domainForm,
                "phone": phoneNumberForm
            }
        };

        const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
        const foo = await axios.post(proxyUrl + "/addCompanyAndAssociation", body, config)
        .then(response => {
            const matchObj = response.data;
            const newMatches = [matchObj, ...incomingMatches];
            setIncomingMatches(newMatches);
            SetDisplayedMatch(0, matchObj);

            // Make the new matches available in local storage and notify other tabs
            localStorage.setItem("hb_callMatches", JSON.stringify(newMatches));
            hubspotBroadcastChannelNotif.postMessage("matchesChanged");
            hubspotBroadcastChannelCti.postMessage("matchesChanged");

            console.log("Company and Association succesfully added");
        }).catch((error) => {
            console.log("Error while creating company: ", error); // TODO: Show error to user
        });

        setOpenCompanyForm(!openCompanyForm);
        document.getElementById("companyCreateForm").reset();
    }
}

CallNotificationHubspot.propTypes = {
    incomingMatches: PropTypes.array,
    cti: PropTypes.object,
    engagementIdRef: PropTypes.any,
    callTime: PropTypes.string
}

export default CallNotificationHubspot;